import { SETUP_WIZARD_SETTING_KEY } from '~/utils/setupWizard'

interface SettingRow {
  key: string
  value?: string | null
}

export function useSetupWizard() {
  const { get, put } = useApi()
  const pending = useState<boolean | null>('setup-wizard-pending', () => null)

  async function refresh(): Promise<boolean> {
    try {
      const response = await get<SettingRow[]>('/admin/settings')
      if (!response.success || !response.data) {
        pending.value = false
        return false
      }
      const row = response.data.find((item) => item.key === SETUP_WIZARD_SETTING_KEY)
      pending.value = row?.value === 'false'
      return pending.value
    } catch {
      pending.value = false
      return false
    }
  }

  async function markCompleted(): Promise<void> {
    await put(`/admin/settings/${SETUP_WIZARD_SETTING_KEY}`, {
      value: 'true',
      type: 'boolean',
      group: 'admin',
    })
    pending.value = false
  }

  return {
    pending,
    refresh,
    markCompleted,
  }
}
